// URL and endpoint constants
module.exports = {
    auth: '/auth/',
    auth_refresh: '/auth/refresh/',
    register: '/create_user/',
    user: '/user/',
    user_me: '/user/me/',
    personagem: '/personagem/',
    campanha: '/campanha/',
    campanha_jogando: '/campanha/jogando/',
    arco: '/arco/',
    classe: '/classe/',
}



// WEBPACK FOOTER //
// ./src/api_config/index.js